import { render, staticRenderFns } from "./InsertTransaction.vue?vue&type=template&id=cb1ad964&scoped=true"
import script from "./InsertTransaction.vue?vue&type=script&lang=js"
export * from "./InsertTransaction.vue?vue&type=script&lang=js"
import style0 from "./InsertTransaction.vue?vue&type=style&index=0&id=cb1ad964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1ad964",
  null
  
)

export default component.exports